import { render } from "./confirmacionasistencia_ingles.vue?vue&type=template&id=6f2c6a66&scoped=true"
import script from "./confirmacionasistencia_ingles.vue?vue&type=script&lang=js"
export * from "./confirmacionasistencia_ingles.vue?vue&type=script&lang=js"

import "./confirmacionasistencia_ingles.vue?vue&type=style&index=0&id=6f2c6a66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2c6a66"]])

export default __exports__